<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Preferencias</h3>
    </div>
    <div class="row">
      <div v-show="configurarFacturacion" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.password_firma_digital"
            id="contrasena_firma_electronica"
            placeholder="Ingrese la contraseña..."
          >
            <span>Contraseña de firma electrónica</span>
            <span
              v-if="errores.password_firma_digital"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.password_firma_digital[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="configurarFacturacion" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.password_firma_digital_confirmation"
            id="contrasena_firma_electronica_confirmation"
            placeholder="Confirme la contraseña..."
          >
            <span>Confirme la contraseña de la firma electrónica</span>
          </input-field>
        </div>
      </div>
      <div v-show="configurarFacturacion" class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="form-group">
            <input-field
              type="text"
              v-model="form.nombre_firma_electronica"
              id="nombre_firma_electronica"
              placeholder="Nombre en el archivo de la firma"
            >
              <span>Nombre de archivo de firma electrónica</span>
              <span
                v-if="errores.nombre_firma_electronica"
                class="helper-text text-danger"
                slot="helper"
              >
                {{ errores.nombre_firma_electronica[0] }}
              </span>
            </input-field>
            <button
              type="button"
              @click="descargarFirma"
              class="btn-info btn--text"
            >
              <i class="fa fa-download"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-show="configurarFacturacion" class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="form-group">
            <input
              @change="onFileChange"
              type="file"
              name="archivo_firma_electronica"
              id="archivo_firma_electronica"
            />
            <label for="archivo_firma_electronica"
              >Archivo de firma electrónica</label
            >
            <button @click="subirFirma" class="btn-success">
              <i class="fa fa-upload"></i><span>Subir</span>
            </button>
          </div>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              placeholder="Seleccione..."
              id="tipoAmbiente"
              v-model="selectedTipoAmbiente"
              :options="tiposAmbiente"
            ></v-select>
            <label for="tipoAmbiente">Tipo de ambiente</label>
            <span
              v-if="errores.id_tipo_ambiente"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.id_tipo_ambiente[0] }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.smtp_user"
            id="smtp_user"
            placeholder="Usuario SMTP"
          >
            <span>Dirección electrónica SMTP (Usuario)</span>
            <span
              v-if="errores.smtp_user"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_user[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.smtp_password"
            id="smtp_password"
            placeholder="Contraseña SMTP"
          >
            <span>Contraseña SMTP (Usuario)</span>
          </input-field>
          <span
            v-if="errores.smtp_password"
            class="helper-text text-danger"
            slot="helper"
          >
            {{ errores.smtp_password[0] }}
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.smtp_password_confirmation"
            id="smtp_password_confirmation"
            placeholder="Confirmación SMTP"
          >
            <span>Confirmar contraseña SMTP (Usuario)</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.motivo_correo"
            id="motivo_correo"
            placeholder="Escriba el motivo..."
          >
            <span>Motivo de correo (Facturación)</span>
            <span
              v-if="errores.motivo_correo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.motivo_correo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.smtp_host"
            id="servidor_smtp"
            placeholder="Host SMTP"
          >
            <span>Servidor SMTP de correos</span>
            <span
              v-if="errores.smtp_host"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.smtp_host[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="int"
            type="number"
            v-model="form.smtp_port"
            id="puerto_servidor"
            placeholder="Puerto SMTP"
          >
            <span>Puerto en el servidor</span>
            <span
              v-if="errores.smtp_port"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.smtp_port[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="servidor_smtp_usa_ssl">
            <input
              type="checkbox"
              v-model="form.smtp_seguridad"
              id="servidor_smtp_usa_ssl"
            />
            <span>El servidor de correo SMTP usa SSL</span>
          </label>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="permitir_facturacion">
            <input
              type="checkbox"
              v-model="form.permitir_facturacion"
              id="permitir_facturacion"
            />
            <span>Permitir facturación</span>
          </label>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select
              name="tipo_facturacion"
              id="tipo_facturacion"
              v-model="form.tipo_facturacion"
            >
              <option value="OF">Offline</option>
              <option value="ON">Online</option>
            </select>
            <label for="tipo_facturacion">Tipo de facturación</label>
          </div>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select
              name="tipo_consulta_dashboard"
              id="tipo_consulta_dashboard"
              v-model="form.tipo_consulta_dashboard"
            >
              <option value="A">A la fecha</option>
              <option value="H">Hoy</option>
              <option value="M">Mes actual</option>
              <option value="P">Personalizado</option>
            </select>
            <label for="tipo_consulta_dashboard">Tipo de consulta inicial en dashboard</label>
          </div>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="int"
            type="number"
            v-model="form.minutos_firma"
            id="minutos_firma"
            placeholder="(En minutos)"
          >
            <span>Intervalo de firma de documentos</span>
            <span
              v-if="errores.minutos_firma"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.minutos_firma[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="int"
            type="number"
            v-model="form.minutos_autorizacion"
            id="minutos_autorizacion"
            placeholder="(En minutos)"
          >
            <span>Intervalo de autorización de documentos</span>
            <span
              v-if="errores.minutos_autorizacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.minutos_autorizacion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="int"
            type="number"
            v-model="form.minutos_email"
            id="minutos_email"
            placeholder="(En minutos)"
          >
            <span>Intervalo de envío de correos</span>
            <span
              v-if="errores.minutos_email"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.minutos_email[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.path_correo"
            id="servidor_smtp"
            placeholder="Nombre de fichero"
          >
            <span>Plantilla de correo (HTML)</span>
            <span
              v-if="errores.path_correo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.path_correo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.path_factura"
            id="plantilla_factura"
            placeholder="Nombre de fichero"
          >
            <span>Plantilla de factura (HTML)</span>
            <span
              v-if="errores.path_factura"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.path_factura[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.path_nota_credito"
            id="plantilla_nc"
            placeholder="Nombre de fichero"
          >
            <span>Plantilla de nota de crédito (HTML)</span>
            <span
              v-if="errores.path_nota_credito"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.path_nota_credito[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.path_retencion"
            id="plantilla_retencion"
            placeholder="Nombre de fichero"
          >
            <span>Plantilla de retención (HTML)</span>
            <span
              v-if="errores.path_retencion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.path_retencion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.path_guia_remision"
            id="plantilla_gr"
            placeholder="Nombre de fichero"
          >
            <span>Plantilla de guía de remisión (HTML)</span>
            <span
              v-if="errores.path_guia_remision"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.path_guia_remision[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.precision"
            id="servidor_smtp"
            placeholder="##.##"
          >
            <span>Precisión de decimales</span>
            <span
              v-if="errores.precision"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.precision[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            v-mask="'###'"
            type="tel"
            v-model="form.dias_alerta"
            id="dias_alerta_pago"
            placeholder="###"
          >
            <span>Días de alerta de pago</span>
            <span
              v-if="errores.dias_alerta"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.dias_alerta[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            v-mask="'###'"
            type="text"
            v-model="form.altura_footer"
            id="altura_footer"
            placeholder="###"
          >
            <span>Altura del Footer (px)</span>
            <span
              v-if="errores.altura_footer"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.altura_footer[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            v-mask="'###'"
            type="text"
            v-model="form.altura_logo"
            id="altura_logo"
            placeholder="###"
          >
            <span>Altura del logo (px)</span>
            <span
              v-if="errores.altura_logo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.altura_logo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="enviar_comprobantes_anulados">
            <input
              v-model="form.enviar_comprobantes_anulados"
              type="checkbox"
              name="enviar_comprobantes_anulados"
              id="enviar_comprobantes_anulados"
            />
            <span
              >Enviar por correo los comprobantes electrónicos anulados</span
            >
          </label>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.smtp_alertas_host"
            id="smtp_alertas_host"
            placeholder="Host SMTP"
          >
            <span>Servidor SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_host"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_host[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            v-mask="'######'"
            type="tel"
            v-model="form.smtp_alertas_port"
            id="smtp_alertas_port"
            placeholder="Puerto SMTP"
          >
            <span>Puerto SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_port"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_port[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <p>
          <label for="smtp_alertas_tls">
            <input
              type="checkbox"
              name="smtp_alertas_tls"
              id="smtp_alertas_tls"
              v-model="form.smtp_alertas_tls"
            /><span>SSL/TLS SMTP (Alertas de saldos)</span>
          </label>
        </p>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.smtp_alertas_usuario"
            id="smtp_alertas_usuario"
            placeholder="Usuario SMTP"
          >
            <span>Usuario SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_usuario"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_usuario[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.smtp_alertas_password"
            id="smtp_alertas_password"
            placeholder="Contraseña SMTP"
          >
            <span>Contraseña SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_password"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_password[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            v-mask="'######'"
            type="tel"
            v-model="form.smtp_alertas_dias_antelacion"
            id="smtp_alertas_dias_antelacion"
            placeholder="# Días"
          >
            <span>Días de antelación</span>
            <span
              v-if="errores.smtp_alertas_dias_antelacion"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_dias_antelacion[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="email"
            v-model="form.smtp_alertas_correo_emisor"
            id="smtp_alertas_correo_emisor"
            placeholder="Escriba el correo de emisión..."
          >
            <span>Correo de emisor SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_correo_emisor"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_correo_emisor[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="text"
            v-model="form.smtp_alertas_nombre_emisor"
            id="smtp_alertas_nombre_emisor"
            placeholder="Escriba el nombre del emisor..."
          >
            <span>Nombre de emisor SMTP (Alertas de saldos)</span>
            <span
              v-if="errores.smtp_alertas_nombre_emisor"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.smtp_alertas_nombre_emisor[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            type="email"
            v-model="form.correos_notificacion_facturacion"
            id="correos_notificacion_facturacion"
            placeholder="Escriba los correos de notificación..."
          >
            <span>Correos de notificación de comprobantes no enviados</span>
            <span
              v-if="errores.correos_notificacion_facturacion"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.correos_notificacion_facturacion[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione un Control de documento..."
              @input="inputControlDocumento"
              id="control_documento"
              v-model="selectedControlDocumento"
              :options="opcionesControlDocumento"
              label="descripcion"
            />
            <label>Control de documento</label>
            <span
              v-if="errores.control_documento"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.control_documento[0] }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="form-field">
          <input-field
            v-mask="'##########'"
            v-model="form.cantidad_documento"
            type="text"
            id="cantidad_documento"
            placeholder="Escriba la cantidad de documento..."
          >
            <span>Cantidad de documento</span>
            <span
              v-if="errores.cantidad_documento"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.cantidad_documento[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="form-field">
          <textarea-field
            v-model="form.correos_notificacion"
            type="email"
            id="correos_notificacion"
            placeholder="Escriba los correos de notificación..."
          >
            <span>Correos de notificación</span>
            <span
              v-if="errores.correos_notificacion"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.correos_notificacion[0] }}
            </span>
          </textarea-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="datepicker-field">
          <date-picker
            v-model="form.fecha_inicio_contrato"
            type="date"
            id="fecha_inicio_contrato"
            placeholder="Escriba la fecha de inicio de contrato..."
          >
          </date-picker>
          <label>Fecha de inicio de contrato</label>
          <span
            v-if="errores.fecha_inicio_contrato"
            class="helper-text text-danger"
            slot="helper"
          >
            {{ errores.fecha_inicio_contrato[0] }}
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="form-field mt-2">
          <div class="datepicker-field datepicker-field--stretch">
            <VueCtkDateTimePicker
              id="fecha_desde"
              v-model="form.fecha_caducidad_firma"
              locale="es"
              no-label
              only-date
              auto-close
              button-now-translation="Ahora"
              format="YYYY-MM-DD"
              formatted="YYYY-MM-DD"
              label="Seleccione fecha..."
            />
            <label>Fecha caducidad de firma</label>
            <span
              v-if="errores.fecha_caducidad_firma"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.fecha_caducidad_firma[0] }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="superadmin == 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="repetir_cabecera_ride">
            <input
              class="is-filled"
              type="checkbox"
              name="repetir_cabecera_ride"
              id="repetir_cabecera_ride"
              v-model="form.repetir_cabecera_ride"
            /><span>Repetir cabecera en RIDE</span>
          </label>
        </div>
      </div>
      <div v-if="superadmin == 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="datos_factura_resumida">
            <input
              class="is-filled"
              type="checkbox"
              name="datos_factura_resumida"
              id="datos_factura_resumida"
              v-model="form.datos_factura_resumida"
            /><span>Datos de Factura Resumidos</span>
          </label>
        </div>
      </div>
      <div v-if="superadmin == 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <label for="datos_persona_resumida">
            <input
              class="is-filled"
              type="checkbox"
              name="datos_persona_resumida"
              id="datos_persona_resumida"
              v-model="form.datos_persona_resumida"
            /><span>Datos de Personas Resumidos</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-4" v-if="superadmin == 'S'">
        <div class="form-field">
          <input-field
            v-mask="'##'"
            v-model="form.dias_envio_automatico"
            type="text"
            id="dias_envio_automatico"
            placeholder="Escriba la cantidad de documento..."
          >
            <span>Días de Envío Automático de Comp. Electrónicos</span>
            <span
              v-if="errores.dias_envio_automatico"
              class="helper-text text-danger"
              slot="helper"
            >
              {{ errores.dias_envio_automatico[0] }}
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="superadmin === 'S'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <p>
            <label for="envio_automatico_fac">
              <input
                type="checkbox"
                v-model="form.envio_automatico_fac"
                id="envio_automatico_fac"
              />
              <span>Envío automático de Facturas Electrónicas</span>
            </label>
          </p>
          <p>
            <label for="envio_automatico_nc">
              <input
                type="checkbox"
                v-model="form.envio_automatico_nc"
                id="envio_automatico_nc"
              />
              <span>Envío automático de Notas de Crédito Electrónicas</span>
            </label>
          </p>
          <p>
            <label for="envio_automatico_gr">
              <input
                type="checkbox"
                v-model="form.envio_automatico_gr"
                id="envio_automatico_gr"
              />
              <span>Envío automático de Guías de Remisión Electrónicas</span>
            </label>
          </p>
          <p>
            <label for="envio_automatico_ret">
              <input
                type="checkbox"
                v-model="form.envio_automatico_ret"
                id="envio_automatico_ret"
              />
              <span>Envío automático de Retenciones Electrónicas</span>
            </label>
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <p v-if="superadmin == 'S'">
            <label for="iva_incluido_exp">
              <input
                type="checkbox"
                v-model="form.iva_incluido_exp"
                id="iva_incluido_exp"
              />
              <span>IVA incluido en exportaciones</span>
            </label>
          </p>
          <p v-if="superadmin == 'S'">
            <label for="modulo_proyecto">
              <input
                type="checkbox"
                v-model="form.modulo_proyecto"
                id="modulo_proyecto"
              />
              <span>Habilitar modulo de Proyectos</span>
            </label>
          </p>
          <p v-if="superadmin === 'S'">
            <label for="no_anular_consumidor_final_aut">
              <input
                type="checkbox"
                v-model="form.no_anular_consumidor_final_aut"
                id="no_anular_consumidor_final_aut"
              />
              <span>No anular consumidor final estado autorizado</span>
            </label>
          </p>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button
        @click="$emit('cerrar')"
        class="btn-danger btn--text"
        type="button"
      >
        <i class="fa fa-sign-out"></i> <span>Cerrar</span>
      </button>
      <button @click="guardarCambios" class="btn-success" type="button">
        <i class="fa fa-save"></i> <span>Guardar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    superadmin: {
      type: String,
      required: false,
      default: 'N'
    }
  },
  data: function () {
    return {
      configurarFacturacion: false,
      opcionesControlDocumento: [
        {
          codigo: "N",
          descripcion: "No Aplica",
        },
        {
          codigo: "M",
          descripcion: "Mensual",
        },
        {
          codigo: "A",
          descripcion: "Anual",
        },
      ],
      selectedFirma: null,
      selectedControlDocumento: null,
      form: {
        tipo_consulta_dashboard: 'A',
        datos_persona_resumida: false,
        datos_factura_resumida: false,
        altura_footer: 120,
        iva_incluido_exp: false,
        modulo_proyecto: false,
        repetir_cabecera_ride: false,
        dias_envio_automatico: 2,
        envio_automatico_fac: false,
        envio_automatico_nc: false,
        envio_automatico_ret: false,
        envio_automatico_gr: false,
        correos_notificacion_facturacion: "",
        tipo_facturacion: "OF",
        enviar_comprobantes_anulados: false,
        password_firma_digital: "",
        password_firma_digital_confirmation: "",
        id_tipo_ambiente: "",
        permitir_facturacion: true,
        smtp_user: "",
        smtp_password: "",
        smtp_password_confirmation: "",
        smtp_port: "",
        smtp_host: "",
        smtp_seguridad: "",
        minutos_firma: 0,
        minutos_email: 0,
        minutos_autorizacion: 0,
        motivo_correo: "",
        nombre_firma_electronica: "",
        path_correo: "",
        path_factura: "",
        path_nota_credito: "",
        path_retencion: "",
        path_guia_remision: "",
        precision: "",
        dias_alerta: 5,
        altura_logo: 60,
        smtp_alertas_host: "",
        smtp_alertas_port: "",
        smtp_alertas_tls: false,
        smtp_alertas_usuario: "",
        smtp_alertas_password: "",
        smtp_alertas_dias_antelacion: "",
        smtp_alertas_correo_emisor: "",
        smtp_alertas_nombre_emisor: "",
        control_documento: "",
        cantidad_documento: "",
        correos_notificacion: "",
        fecha_inicio_contrato: "",
        no_anular_consumidor_final_aut: false,
      },
      errores: {
        password_firma_digital: undefined,
        password_firma_digital_confirmation: undefined,
        id_tipo_ambiente: undefined,
        permitir_facturacion: undefined,
        smtp_user: undefined,
        smtp_password: undefined,
        smtp_password_confirmation: undefined,
        smtp_port: undefined,
        smtp_host: undefined,
        smtp_seguridad: undefined,
        minutos_firma: undefined,
        minutos_email: undefined,
        minutos_autorizacion: undefined,
        motivo_correo: undefined,
        nombre_firma_electronica: undefined,
        path_correo: undefined,
        path_factura: undefined,
        path_nota_credito: undefined,
        path_retencion: undefined,
        precision: undefined,
        path_guia_remision: undefined,
        dias_alerta: undefined,
        altura_logo: undefined,
        smtp_alertas_host: undefined,
        smtp_alertas_port: undefined,
        smtp_alertas_tls: undefined,
        smtp_alertas_usuario: undefined,
        smtp_alertas_password: undefined,
        smtp_alertas_dias_antelacion: undefined,
        smtp_alertas_correo_emisor: undefined,
        smtp_alertas_nombre_emisor: undefined,
        control_documento: undefined,
        cantidad_documento: undefined,
        correos_notificacion: undefined,
        fecha_inicio_contrato: undefined,
      },
      url: url,
      tiposAmbiente: [],
      selectedTipoAmbiente: null,
      int: int,
    };
  },
  methods: {
    descargarFirma: function () {
      window.open(url + "/firma-digital", "_blank");
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) this.selectedFirma = null;
      this.selectedFirma = files[0];
    },
    subirFirma: function () {
      if (this.selectedFirma != null) {
        let data = new FormData();
        data.append("firma_electronica", this.selectedFirma);
        axios({
          method: "post",
          url: url + "/parametros/preferencias/subir-firma",
          data: data,
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then(({ data }) => {
            this.form.nombre_firma_electronica = data.path_firma_digital;
            swal.fire(
              "La firma electrónica fue subida exitósamente.",
              "Realizado",
              "success"
            );
          })
          .catch(() => {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          });
      }
    },
    limpiarErrores: function () {
      this.errores = {
        smtp_alertas_host: undefined,
        smtp_alertas_port: undefined,
        smtp_alertas_tls: undefined,
        smtp_alertas_usuario: undefined,
        smtp_alertas_password: undefined,
        smtp_alertas_dias_antelacion: undefined,
        smtp_alertas_correo_emisor: undefined,
        smtp_alertas_nombre_emisor: undefined,
        password_firma_digital: undefined,
        password_firma_digital_confirmation: undefined,
        id_tipo_ambiente: undefined,
        permitir_facturacion: undefined,
        smtp_user: undefined,
        smtp_password: undefined,
        smtp_password_confirmation: undefined,
        smtp_port: undefined,
        smtp_host: undefined,
        smtp_seguridad: undefined,
        minutos_firma: undefined,
        minutos_email: undefined,
        minutos_autorizacion: undefined,
        motivo_correo: undefined,
        nombre_firma_electronica: undefined,
        path_correo: undefined,
        path_factura: undefined,
        path_nota_credito: undefined,
        path_retencion: undefined,
        precision: undefined,
        dias_alerta: undefined,
        altura_logo: undefined,
        enviar_comprobantes_anulados: undefined,
        control_documento: undefined,
        cantidad_documento: undefined,
        correos_notificacion: undefined,
        fecha_inicio_contrato: undefined,
      };
    },
    inputControlDocumento: function () {
      if (this.selectedControlDocumento)
        this.form.control_documento = this.selectedControlDocumento.codigo;
      else {
        this.form.control_documento = "";
        this.selectedControlDocumento = null;
      }
    },
    guardarCambios: function () {
      let that = this;
      this.limpiarErrores();
      let precision = parseFloat(this.form.precision);
      if (!isNaN(precision) && (precision > 6 || precision < 2)) {
        swal(
          "La precisión máxima es de 6 y la mínima es de 2.",
          "Mensaje",
          "warning"
        );
        return;
      }
      axios
        .post(this.url + "/parametros/preferencias", that.form)
        .then(function (response) {
          swal({
            type: "success",
            title: "Realizado",
            text: "Los parámetros de preferencias han sido actualizados.",
          });
        })
        .catch(function (error) {
          let response = error.response;
          if (response !== null) {
            let status = response.status;
            if (status === 422) {
              that.errores = response.data.errors;
            }
          }
        });
    },
    cargarDatos: function () {
      let that = this;
      axios
        .get(this.url + "/parametros/preferencias/datos")
        .then(function (response) {
          that.tiposAmbiente = response.data.tiposAmbiente;
          that.configurarFacturacion = response.data.configurarFacturacion;
          if (response.data.configuracionEmpresa !== null) {
            let configuracionEmpresa = response.data.configuracionEmpresa;
            that.form.tipo_consulta_dashboard = configuracionEmpresa.tipo_consulta_dashboard;
            that.form.datos_factura_resumida = configuracionEmpresa.datos_factura_resumida === 'S';
            that.form.datos_persona_resumida = configuracionEmpresa.datos_persona_resumida === 'S';
            that.form.altura_footer = configuracionEmpresa.altura_footer;
            that.form.iva_incluido_exp = configuracionEmpresa.iva_incluido_exp === 'S';
            that.form.modulo_proyecto = configuracionEmpresa.modulo_proyecto === 'S';
            that.form.repetir_cabecera_ride = configuracionEmpresa.repetir_cabecera_ride === 'S';
            that.form.dias_envio_automatico = configuracionEmpresa.dias_envio_automatico;
            that.form.envio_automatico_fac = configuracionEmpresa.envio_automatico_fac === 'S';
            that.form.envio_automatico_nc = configuracionEmpresa.envio_automatico_nc === 'S';
            that.form.envio_automatico_gr = configuracionEmpresa.envio_automatico_gr === 'S';
            that.form.envio_automatico_ret = configuracionEmpresa.envio_automatico_ret === 'S';
            that.form.correos_notificacion_facturacion =
              configuracionEmpresa.correos_notificacion_facturacion;
            that.form.minutos_firma = configuracionEmpresa.minutos_firma;
            that.form.tipo_facturacion = configuracionEmpresa.tipo_facturacion;
            that.form.enviar_comprobantes_anulados =
              configuracionEmpresa.enviar_comprobantes_anulados === "S";
            that.form.minutos_email = configuracionEmpresa.minutos_email;
            that.form.minutos_autorizacion =
              configuracionEmpresa.minutos_autorizacion;
            that.form.motivo_correo = configuracionEmpresa.motivo_correo;
            that.form.permitir_facturacion =
              configuracionEmpresa.permitir_facturacion === "S";
            that.form.smtp_user = configuracionEmpresa.smtp_user;
            that.form.smtp_port = configuracionEmpresa.smtp_port;
            that.form.smtp_host = configuracionEmpresa.smtp_host;
            that.form.smtp_seguridad =
              configuracionEmpresa.smtp_seguridad === "S";
            that.form.id_tipo_ambiente = configuracionEmpresa.id_tipo_ambiente;
            that.form.path_correo = configuracionEmpresa.path_html_correo;
            that.form.path_factura = configuracionEmpresa.path_factura_ride;
            that.form.path_nota_credito = configuracionEmpresa.path_nc_ride;
            that.form.precision = configuracionEmpresa.precision;
            that.form.path_retencion = configuracionEmpresa.path_ret_ride;
            that.form.path_guia_remision =
              configuracionEmpresa.path_guia_remision;
            that.form.nombre_firma_electronica =
              configuracionEmpresa.path_firma_digital;
            that.form.dias_alerta = configuracionEmpresa.dias_alerta;
            that.form.altura_logo = configuracionEmpresa.altura_logo;
            that.form.smtp_alertas_host =
              configuracionEmpresa.smtp_alertas_host;
            that.form.smtp_alertas_port =
              configuracionEmpresa.smtp_alertas_port;
            that.form.smtp_alertas_tls =
              configuracionEmpresa.smtp_alertas_tls === "S";
            that.form.smtp_alertas_usuario =
              configuracionEmpresa.smtp_alertas_usuario;
            that.form.smtp_alertas_password =
              configuracionEmpresa.smtp_alertas_password;
            that.form.smtp_alertas_dias_antelacion =
              configuracionEmpresa.smtp_alertas_dias_antelacion;
            that.form.smtp_alertas_correo_emisor =
              configuracionEmpresa.smtp_alertas_correo_emisor;
            for (let i = 0; i < that.tiposAmbiente.length; i++)
              if (
                that.tiposAmbiente[i].id_tipo_ambiente ===
                that.form.id_tipo_ambiente
              ) {
                that.selectedTipoAmbiente = that.tiposAmbiente[i];
                break;
              }
            that.form.control_documento =
              configuracionEmpresa.control_documento;
            if (
              that.form.control_documento != null &&
              that.form.control_documento != ""
            )
              that.selectedControlDocumento =
                that.opcionesControlDocumento.find(
                  (opcion) => that.form.control_documento == opcion.codigo
                );
            that.form.cantidad_documento =
              configuracionEmpresa.cantidad_documento;
            that.form.correos_notificacion =
              configuracionEmpresa.correos_notificacion;
            that.form.fecha_inicio_contrato =
              configuracionEmpresa.fecha_inicio_contrato;
            that.form.no_anular_consumidor_final_aut = configuracionEmpresa.no_anular_consumidor_final_aut === "S";
          }
        });
    },
  },
  mounted: function () {
    this.cargarDatos();
  },
  watch: {
    selectedTipoAmbiente: function (value) {
      if (value !== undefined && value !== null)
        this.form.id_tipo_ambiente = value.id_tipo_ambiente;
      else this.form.id_tipo_ambiente = "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue